export default __webpack_public_path__ + "static/media/banner-1.d37e6cb1.jpg";